<template>
    <div class="mx-auto fixed-width-form">
        <legend>Поиск партнера</legend>
        <form action="get" @submit.prevent="submit">
            <v-select v-model="partner" label="Reception" :filterable="false"
                      :options="partners" @search="onSearch">
                <template slot="no-options">
                    начните вводить...
                </template>
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.Reception }} {{option[CustomerGroup]}}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                        {{ option.Reception }} {{option['PartnerGroup.Name']}}
                    </div>
                </template>
            </v-select>
        </form>
    </div>
</template>
<script>

import { get } from '@/admin/services/api/http-utils';

export default {
  components: {},
  data() {
    return {
      partner: {},
      partners: [],
    };
  },
  watch: {
    partner(newVal) {
      if (newVal && newVal.Id) {
        this.$router.push({ name: 'partner', params: { id: newVal.Id } });
      }
    },
  },
  methods: {
    onSearch(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      get(`${process.env.VUE_APP_API_HOST}admin/order-add-form/search-customers?q=${(search)}`)
        .then((res) => {
          vm.partners = res.data;
          loading(false);
        });
    }, 350),
  },
};
</script>
